import { track } from '../analytics';

/**
 * This hook is used to get access to the tracking function and dispatch custom events to the analytics.
 * @returns {UserTrackingContextData}
 */
export var useTracking = function useTracking() {
  return {
    track: track
  };
};